module.exports = __webpack_public_path__ + "assets/img/bf.b384c970.jpg";